export default __webpack_public_path__ + "static/media/12-silent-brainstorming.9382e0fd.svg";